module.exports = ".loading-bar{\n    background-color: rgb(0, 77, 143);\n}\n\n.block{\n    width: 100%;\n    height: 99%;\n    position: absolute;\n    z-index: 999;\n    background-color: rgb(0, 0, 0);\n    opacity: 0.1;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_shared/loader/loader.component.css
// module id = ./src/app/_shared/loader/loader.component.css
// module chunks = main